import { inkFontTokens } from '@ds/tokens';
import styled from '@emotion/styled';

const FontBodyL = styled.div`
    ${inkFontTokens.fontBodyL}
`;

export default FontBodyL;
